// App.js
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import MonerisCheckout from './components/MonerisCheckout';
import PaymentForm from './components/PaymentForm';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Routes>
          {/* Ruta pública para el checkout */}
          <Route path="/checkout/:paymentId" element={<MonerisCheckout />} />
          
          {/* Ruta de login */}
          <Route path="/login" element={<Login />} />
          
          {/* Ruta protegida para el admin */}
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <PaymentForm />
              </PrivateRoute>
            } 
          />
          
          {/* Redirigir la ruta raíz al login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Redirigir cualquier otra ruta al login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;